import { Col, Row, Switch, Badge } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaCheck } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Get } from "../../config/api/get";
import { ADMIN, UPLOADS_URL } from "../../config/constants/api";
import { Put } from "../../config/api/put";
import Swal from "sweetalert2";

const UserDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  const [active, setActive] = useState(false);
  const [loading, setLoading] = useState(true);
  const token = useSelector((state) => state.user.userToken);
  const location = useLocation();
  const status = location?.state?.status;
  useEffect(() => {
    if (status === "INACTIVE") {
      setActive(false);
    } else {
      setActive(true);
    }
    // eslint-disable-next-line
  }, []);
  const getUserDetails = () => {
    setLoading(true);
    Get(`${ADMIN.getUser}${id}`, token)
      .then((response) => {
        setUserDetails(response?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching user details", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line
  }, []);
  const onChange = (checked) => {
    console.log(`switch to ${checked}`);
    handleClick(!active);
  };
  const banUser = (id, status, value) => {
    Put(`${ADMIN.toggleUser}${id}`, token, { status })
      .then((response) => {
        if (response.status) {
          swal("System Alert!", response?.message, "success");
          setActive(value);
        }
      })
      .catch((err) => {
        let message = err?.response?.data?.message;
        console.log(":::;", err);
        if (message) swal("Oops!", message, "error");
      });
  };
  const handleClick = (value) => {
    if (value) {
      Swal.fire({
        title: "System Alert!",
        text: "Are you sure you want to mark as active?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#18377E",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          banUser(userDetails?._id, "ACTIVE", value);
        }
      });
    } else {
      Swal.fire({
        title: "System Alert!",
        text: "Are you sure you want to mark as inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#18377E",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Confirm",
        showCloseButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          banUser(userDetails?._id, "INACTIVE", value);
        }
      });
    }
  };
  return (
    <Row justify="center">
      <Col md={23} xs={22}>
       {!loading && <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
        >
          <div className="flex justify-between mx-1 lg:mx-8 mb-4">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                User Details
              </h3>
            </div>
            <div className="flex justify-center items-center customSwitch1">
              <p
                className={`font-euclid text-sm max-sm:text-xs font-bold mr-2 ${
                  active ? "text-[#333333]" : "text-gray-400"
                }`}
              >
                Active
              </p>
              <Switch
                checkedChildren={
                  <FaCheck size={24} className="mt-1 text-white" />
                }
                unCheckedChildren={
                  <IoCloseSharp size={24} className="text-[#8D8D8D] ml-4" />
                }
                checked={active}
                // defaultChecked
                onChange={onChange}
              />
              <p
                className={`font-euclid text-sm max-sm:text-xs font-bold ml-2 ${
                  !active ? "text-[#f83131]" : "text-gray-400"
                }`}
              ></p>
              Ban User
            </div>
          </div>

          
          <Row justify="center">
            <Col xs={22} sm={18} md={18} xl={12}>
            {userDetails?.subscription &&<Badge.Ribbon
            text={userDetails?.subscription?.plan?.title}
            className="profile-badge" style={{ fontSize: "12px" , padding: "5px 10px", fontWeight:'bold', backgroundColor:"#d7a641"}}
          ></Badge.Ribbon>}
              <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-center justify-center sm:py-12 py-6">
                <img
                  src={userDetails?.image 
                    ? UPLOADS_URL + userDetails.image 
                    : "/assets/images/avatar.png"}
                  onError={(e) => {
                    e.target.src = "/assets/images/avatar.png";
                  }}
                  alt="profile"
                  style={{
                    height: "180px",
                    width: "180px",
                    borderRadius: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />

                <div className="flex justify-center items-center my-4">
                  <div className="flex flex-col items-start lg:mr-32 mr-8">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      First Name
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userDetails?.firstName}
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Contact Number
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userDetails?.phone}
                    </p>
                    {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Gender
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      Male
                    </p> */}
                  </div>
                  <div className="flex flex-col items-start">
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Last Name
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userDetails?.lastName}
                    </p>
                    <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Email Address
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      {userDetails?.email}
                    </p>
                    {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                      Sex Orientation
                    </h5>
                    <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                      Straight
                    </p> */}
                  </div>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <button
                    className="uppercase bg-button py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4"
                    onClick={() =>
                      navigate("/reportManagement", {
                        state: { userId: userDetails?._id },
                      })
                    }
                  >
                    See Luxury Car Bookings
                  </button>
                  {/* <button
                    className="w-full uppercase bg-transparent border border-black py-4 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-md:text-[10px] max-md:py-2 max-md:px-4 mt-4"
                    onClick={() => navigate("/reservation")}
                  >
                    see rides history
                  </button> */}
                </div>
              </div>
            </Col>
          </Row>
        </div>}
      </Col>
    </Row>
  );
};

export default UserDetails;
